import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}api/admin/facebook-template`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const facebookTemplateApi = {
  get: ({ params }) => {
    return instance().get('/info', { params })
  },
  getAll: ({ params }) => {
    return instance().get('', { params })
  },
  post: ({ data }) => {
    return instance().post('', data)
  },
  put: ({ data }) => {
    return instance().put('', data)
  },
  delete: ({ data }) => {
    return instance().delete('', { data })
  },
  postSendMessage: ({ data }) => {
    return instance().post('/send-message', data)
  }
}

export default facebookTemplateApi



// WEBPACK FOOTER //
// ./src/api/facebook-template.js